<template>
  <router-view />
</template>

<script setup>
  import { onMounted } from 'vue'

  onMounted(() => {
    window.version = `MS Landing version: ${VUE_APP_VERSION}`
  })
</script>

<style lang="scss">
  html,
  body {
    margin: 0;
    font-family: Arial, sans-serif, Helvetica Neue, Helvetica;
  }

  * {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }

  #gnt_center {
    display: none !important;
  }
  .gnt-notice-tabs {
    pointer-events: none;
  }
  .gnt-notice-tab {
    pointer-events: all;
  }
  .gnt-nav {
    display: none !important;
  }
  #onetrust-banner-sdk button {
    margin-bottom: 5px !important;
  }
</style>
